exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-box[data-v-506b846e] {\n  padding-left: 20px;\n}\n", ""]);

// exports
